import { DBFind, DBFindOne, DBRemove, DBUpdateOne } from '@weblite/persist'
import { PinData } from '$logic/pin/types'

const COLLECTION = 'pinnedMessages'
export const pinnedMessagesStorage = {
  replace(pinInfo: PinData) {
    return DBUpdateOne(COLLECTION, [pinInfo.roomId], { $set: pinInfo }, true)
  },

  get(roomId: string): Promise<PinData> {
    return DBFindOne(COLLECTION, [roomId])
  },

  findMany(keyRanges: any, options?: any) {
    return DBFind(COLLECTION, keyRanges, options)
  },
}
